import { PRODUCT_TYPE } from './Types';

export const initialProductState = {
  isLoading: false,
  reviewLoading: false,
  reviews: [],
  products: [],
  productResponse: null,
  error: null,
  productDetails: {},
};

export function productReducer(state, action) {
  switch (action.type) {
    case PRODUCT_TYPE.PRODUCTS:
      return { ...state, products: action.payload, error: null };
    case PRODUCT_TYPE.IS_LOADING:
      return { ...state, isLoading: action.payload };
    case PRODUCT_TYPE.PRODUCT_RESPONSE:
      return { ...state, productResponse: action.payload, error: null };
    case PRODUCT_TYPE.PRODUCT_DETAILS:
      return { ...state, productDetails: action.payload, error: null };
    case PRODUCT_TYPE.ERROR:
      return { ...state, error: action.payload };
    case PRODUCT_TYPE.REVIEW_LOADING:
      return { ...state, reviewLoading: action.payload };
    case PRODUCT_TYPE.REVIEWS:
      return { ...state, reviews: action.payload };
    default:
      return state;
  }
}
